import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// import Card from "../../UI/Card";
import {
  Card,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  useMediaQuery,
} from "@mui/material";

import "./Jobs.css";

import JobsService from "../../../../redux/services/categories/jobs/programs";

const Jobs = () => {

  const [category, setCategory] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    JobsService.subPrograms('jobs').then((res) => {
      setCategory(res.data.places);
    //   //console.log(res.data);
      setIsLoading(false);
    });
  }, [isLoading]);

  return (
    <section className="learning__program__secttion">
      <Card>
        <div className="learning__container">
          {category.map((t) => (
            <Link to={`/programs/jobs/${t.id}`} state={t}>
              <div className={`leaning__box opened`} key={t.id}>
                <div className="learning__image">
                  <img
                    src={`https://maharttafl.com/images/${t.avatar}`}
                    alt=""
                  />
                </div>
                <p className="leaning__title">{t.name}</p>
              </div>
            </Link>
          ))}
        </div>
      </Card>
    </section>
  );
};

export default Jobs;
